// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 10rem;
  z-index: 2;
  background: rgba(0, 0, 0, 0.3);
}

.header-logo {
  border-radius: 20px;
  width: 230px;
  /* set the desired width */
  height: 70px;
  /* set the desired height */
  top: 14px;
  position: absolute;
  display: flex;
  justify-content: flex-start;
  z-index: 3;
  border: 6px solid #edf2f4;
  align-items: center;
  justify-content: center;
}


.header-name.fade-in {
  opacity: 0;
  animation: fade-in 1.5s forwards;
}

@keyframes fade-in {
  to {
    opacity: 1;
  }
}


.header-name {
  transition: opacity 0.3s ease-in-out;
  font-size: 2rem;
  animation: show 0.5s;
  text-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
}


.header-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  align-items: center;
  padding: 3.3rem;
  text-align: right;
  color: lightgrey;
  z-index: 2;
  transition: all 0.2s linear;
}

button {
  all: unset;
}

.nav-item {
  position: relative;
  display: inline-block;
  font-size: 2.6rem;
  margin-right: 4rem;
}

.nav-item:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 0.4rem;
  opacity: 0;
  bottom: -1rem;
  left: 0;
  transition: all 0.1s ease-in-out;
  background-color: lightgrey;
}

.nav-item:hover:after {
  opacity: 1;
}

@media (max-width: 1000px) {
  .header {
    height: 6rem;
  }

  .header-container {
    padding: 2rem;
    align-items: center;
  }
}

@media (max-width: 600px) {
  .header {
    height: 6rem;
  }

  .header-logo {
    display: none;
  }

  .header-container {
    align-items: center;
  }

  .nav-item {
    font-size: 1.2rem;
    margin-right: 3rem;
  }
}

.progress-bar {
  position: fixed;
  top: 10rem;
  left: 0;
  height: 4px;
  background-color: white;
  width: 0;
  transition: width 0.3s ease-in-out;
  bottom: 0;
}

@media (max-width: 600px) {
  .header {
    height: 6rem;
  }

  .header-logo {
    display: none;
  }

  .header-container {
    align-items: center;
  }

  .nav-item {
    font-size: 1.2rem;
    margin-right: 3rem;
  }

  .progress-bar {
    position: fixed;
    top: 6rem;
    left: 0;
    height: 4px;
    background-color: white;
    width: 0;
    transition: width 0.3s ease-in-out;
    bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,UAAU;EACV,aAAa;EACb,OAAO;EACP,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,QAAQ;EACR,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,uBAAuB;IACvB,QAAQ;IACR,kCAAkC;IAClC,SAAS;EACX;AACF","sourcesContent":[".header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 10rem;\n  z-index: 2;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.header-logo {\n  border-radius: 20px;\n  width: 230px;\n  /* set the desired width */\n  height: 70px;\n  /* set the desired height */\n  top: 14px;\n  position: absolute;\n  display: flex;\n  justify-content: flex-start;\n  z-index: 3;\n  border: 6px solid #edf2f4;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.header-name.fade-in {\n  opacity: 0;\n  animation: fade-in 1.5s forwards;\n}\n\n@keyframes fade-in {\n  to {\n    opacity: 1;\n  }\n}\n\n\n.header-name {\n  transition: opacity 0.3s ease-in-out;\n  font-size: 2rem;\n  animation: show 0.5s;\n  text-shadow: 0 0 40px rgba(0, 0, 0, 0.1);\n}\n\n\n.header-container {\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  margin: 0 auto;\n  align-items: center;\n  padding: 3.3rem;\n  text-align: right;\n  color: lightgrey;\n  z-index: 2;\n  transition: all 0.2s linear;\n}\n\nbutton {\n  all: unset;\n}\n\n.nav-item {\n  position: relative;\n  display: inline-block;\n  font-size: 2.6rem;\n  margin-right: 4rem;\n}\n\n.nav-item:after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 0.4rem;\n  opacity: 0;\n  bottom: -1rem;\n  left: 0;\n  transition: all 0.1s ease-in-out;\n  background-color: lightgrey;\n}\n\n.nav-item:hover:after {\n  opacity: 1;\n}\n\n@media (max-width: 1000px) {\n  .header {\n    height: 6rem;\n  }\n\n  .header-container {\n    padding: 2rem;\n    align-items: center;\n  }\n}\n\n@media (max-width: 600px) {\n  .header {\n    height: 6rem;\n  }\n\n  .header-logo {\n    display: none;\n  }\n\n  .header-container {\n    align-items: center;\n  }\n\n  .nav-item {\n    font-size: 1.2rem;\n    margin-right: 3rem;\n  }\n}\n\n.progress-bar {\n  position: fixed;\n  top: 10rem;\n  left: 0;\n  height: 4px;\n  background-color: white;\n  width: 0;\n  transition: width 0.3s ease-in-out;\n  bottom: 0;\n}\n\n@media (max-width: 600px) {\n  .header {\n    height: 6rem;\n  }\n\n  .header-logo {\n    display: none;\n  }\n\n  .header-container {\n    align-items: center;\n  }\n\n  .nav-item {\n    font-size: 1.2rem;\n    margin-right: 3rem;\n  }\n\n  .progress-bar {\n    position: fixed;\n    top: 6rem;\n    left: 0;\n    height: 4px;\n    background-color: white;\n    width: 0;\n    transition: width 0.3s ease-in-out;\n    bottom: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
